import { InlineText2 } from '@cian/ui-kit';
import * as React from 'react';
import { Counter } from '../Counter';
import * as styles from './GuestsDropdown.css';
import * as stylesCommon from '../FiltersCommon/FiltersCommon.css';
import { mergeStyles } from '@cian/utils';

interface IGuestsDropdownProps {
  adults: number;
  children: number;
  onChangeAdults(count: number): void;
  onChangeChildren(count: number): void;
}

export const GuestsDropdown = ({ adults, children, onChangeAdults, onChangeChildren }: IGuestsDropdownProps) => {
  return (
    <div {...mergeStyles(stylesCommon['dropdown'], styles['dropdown'])}>
      <div className={styles['field']}>
        <span className={styles['label']}>
          <InlineText2 whiteSpace="nowrap">Взрослые</InlineText2>
        </span>

        <Counter value={adults} minValue={1} maxValue={50} onChange={onChangeAdults} />
      </div>

      <div className={styles['field']}>
        <span className={styles['label']}>
          <InlineText2 whiteSpace="nowrap">Дети до 18-ти лет</InlineText2>
        </span>

        <Counter value={children} maxValue={9} onChange={onChangeChildren} />
      </div>
    </div>
  );
};
